import { PATTERN_US_PASSPORT, PATTERN_US_PASSPORT_CARD } from "@ca-dmv/core";
import { isMobile } from "react-device-detect";
import { Documents } from "../helpers/constants";

const formTitle = {
  [Documents.PASSPORT]: (t, isAbbyyFlow) =>
    isAbbyyFlow || !isMobile
      ? t(
          "screens-Dashboard-Passport-Legend",
          "Please provide your U.S. Passport Number and Expiration Date."
        )
      : t(
          "screens-Dashboard-AIDPassport-Legend",
          "Please confirm your U.S. Passport Number and Expiration Date."
        ),
  [Documents.PASSPORT_CARD]: (t, isAbbyyFlow) =>
    isAbbyyFlow || !isMobile
      ? t(
          "screens-Dashboard-PassportCard-Legend",
          "Please provide your U.S. Passport Card Number and Expiration Date."
        )
      : t(
          "screens-Dashboard-AIDPassportCard-Legend",
          "Please confirm your U.S. Passport Card Number and Expiration Date."
        ),
  default: (t) =>
    t(
      "screens-Dashboard-ExpirationDate-Legend",
      "Please provide your Expiration Date."
    ),
};

const expLabel = {
  [Documents.PASSPORT]: (t) =>
    t(
      "screens-Dashboard-Passport-PassportExpirationLabel",
      "Passport Expiration Date"
    ),
  [Documents.PASSPORT_CARD]: (t) =>
    t(
      "screens-Dashboard-PassportCard-PassportExpirationLabel",
      "Passport Card Expiration Date"
    ),
  default: (t) =>
    t("screens-Dashboard-ExpirationDate-Label", "Expiration Date"),
};

const label = {
  [Documents.PASSPORT]: (t) =>
    t("screens-Dashboard-Passport-PassportNumberLabel", "Passport Number"),
  [Documents.PASSPORT_CARD]: (t) =>
    t(
      "screens-Dashboard-PassportCard-PassportNumberLabel",
      "Passport Card Number"
    ),
};

const confirmLabel = {
  [Documents.PASSPORT]: (t) =>
    t(
      "screens-Dashboard-Passport-ConfirmPassportNumberLabel",
      "Confirm Passport Number"
    ),
  [Documents.PASSPORT_CARD]: (t) =>
    t(
      "screens-Dashboard-PassportCard-ConfirmPassportNumberLabel",
      "Confirm Passport Card Number"
    ),
};

const passportHint = {
  [Documents.PASSPORT]: (t) =>
    t(
      "screens-Dashboard-Passport-PassportNumHint",
      "Passport numbers are between 6-9 characters"
    ),
  [Documents.PASSPORT_CARD]: (t) =>
    t(
      "screens-Dashboard-PassportCard-PassportNumHint",
      "Passport Card numbers begin with the letter C followed by 8 numbers"
    ),
};

const pattern = {
  [Documents.PASSPORT]: PATTERN_US_PASSPORT,
  [Documents.PASSPORT_CARD]: PATTERN_US_PASSPORT_CARD,
};

const minLength = {
  [Documents.PASSPORT]: 6,
  [Documents.PASSPORT_CARD]: 9,
};

const maxLength = {
  [Documents.PASSPORT]: 9,
  [Documents.PASSPORT_CARD]: 9,
};

const hint = {
  [Documents.PASSPORT]: (t) =>
    t("screens-Dashboard-Passport-NumHint", "Passport numbers must match"),
  [Documents.PASSPORT_CARD]: (t) =>
    t(
      "screens-Dashboard-PassportCard-NumHint",
      "Passport Card numbers must match"
    ),
};

const getFormTitle = (documentType, t, isAbbyyFlow) => {
  if (documentType in formTitle) {
    return formTitle[documentType](t, isAbbyyFlow);
  }

  return formTitle.default(t);
};

const getExpLabel = (documentType, t) => {
  if (documentType in expLabel) {
    return expLabel[documentType](t);
  }

  return expLabel.default(t);
};

export {
  getFormTitle,
  getExpLabel,
  label,
  confirmLabel,
  expLabel,
  passportHint,
  pattern,
  minLength,
  maxLength,
  hint,
};
